import React from 'react';
import { FaTrophy, FaCoins, FaGamepad } from 'react-icons/fa';
import { useAttempts } from '../hooks/useAttempts';
import { useGameState } from '../hooks/useGameState';
import { useWalletBalance } from '../hooks/useWalletBalance';

interface PlayerStats {
  totalAttempts: number;
  successfulAttempts: number;
  tokenBalance: number;
  nextAttemptCost: number;
}

interface PlayerStatsProps {
  telegramId?: string;
}

export default function PlayerStats({ telegramId = "123456789" }: PlayerStatsProps) {
  const { totalAttempts: globalTotalAttempts } = useAttempts();
  const { gameState } = useGameState();
  const { solUsdValue, solBalance } = useWalletBalance();
  
  const [stats, setStats] = React.useState<PlayerStats>({
    totalAttempts: 0,
    successfulAttempts: 1,
    tokenBalance: 0,
    nextAttemptCost: 0
  });

  // Calculate SOL price per unit
  const solPricePerUnit = solBalance > 0 ? solUsdValue / solBalance : 0;

  React.useEffect(() => {
    // Mock API call to fetch stats
    const mockStats = {
      totalAttempts: globalTotalAttempts,
      successfulAttempts: 0,
      tokenBalance: 1000,
      nextAttemptCost: gameState.currentAttemptCost
    };
    setStats(mockStats);
  }, [telegramId, globalTotalAttempts, gameState.currentAttemptCost]);

  const successRate = stats.totalAttempts > 0
    ? Math.round((stats.successfulAttempts / stats.totalAttempts) * 100)
    : 0;

  // Calculate USD cost for next attempt
  const nextAttemptUsdCost = stats.nextAttemptCost * solPricePerUnit;

  return (
    <div className="stats-grid">
      <div className="nes-container is-rounded">
        <FaTrophy className="stats-icon" />
        <h3>Success Rate</h3>
        <p>{successRate}%</p>
        <small>
          {stats.successfulAttempts} / {stats.totalAttempts} attempts
        </small>
      </div>

      <div className="nes-container is-rounded">
        <FaCoins className="stats-icon" />
        <h3>Tries</h3>
        <p>{stats.totalAttempts} Total</p>
        <small>{stats.successfulAttempts} successful attempts</small>
      </div>

      <div className="nes-container is-rounded">
        <FaGamepad className="stats-icon" />
        <h3>Next Attempt</h3>
        <p>${nextAttemptUsdCost.toFixed(2)} USD</p>
        <small>{stats.nextAttemptCost.toFixed(3)} SOL</small>
      </div>
    </div>
  );
} 